import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import * as wActs from "../actions/website-actions";
import * as wConsts from "../consts/website-consts";
import SearchItem from "../components/searchitem";
import * as pActs from "../actions/profiles-actions";
import Pager from "../components/pager";
import ProfilesList from "../components/profileslist";
import ProfilesFilter from "../components/profilesfilter";



import {FormattedMessage} from "react-intl";


class SearchList extends Component {


  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "searchlist" });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }
  render() {
    let inc = "";
    if(typeof window === "undefined") {
      inc = wActs.getParameterByName("include","https://www.fake.com/" + this.props.WebPage.ServerParams.Query,"")
    } else {
      inc = wActs.getParameterByName("include",window.location.href,"")
    }
    if(!wActs.isNullOrEmpty(inc)) { //This Page Is A Temp Hardcode, When City Not Defined
      return (
        <div className="container">
          <SeoHeaders Position={"Top"}/>
          <ProfilesFilter filters={this.props.WebPage.Menu.Filter[0].Menu} pos={"top"} />
          <ProfilesList pageType={this.props.pageType} />
        </div>
      )
    }


    let itms = [];
    if(this.props.Search.Loaded) {
      itms = this.props.Search.ApiResult.Result;
    }
    if(this.props.Groups.Loaded) {
      itms = this.props.Groups.ApiResult.Result;
    }

    let ref = typeof window === "undefined" ? this.props.WebPage.ServerParams.Referer : window.location.href;

    return (
      <div className="container" style={{maxWidth: "765px", background: "#fff"}} >
        <SeoHeaders Position={"Top"}/>
        <div className="white-section default-content" style={{background: "white", paddingTop: "15px"}}>
          <div className="models-listing">
            <div className={"row"} style={{fontSize: "inherit"}}>
              {!this.props.Search.Loaded && !this.props.Groups.Loaded &&
              <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
              </p>
              }
              {this.props.Search.Loaded &&
              <React.Fragment>
                {itms.length === 0 &&
                  <div className="row">
                    <div className="col_50" id={"noresultsimg"}>
                      <img src={"/imgs/no-results-img.jpg"} width={"200"} height={"200"} alt={"Not Found"}/>
                    </div>
                    <div className="col_50" id={"noresults"}>
                      <h4><FormattedMessage id={"page.noresultsfound"}>{(...content) => content}</FormattedMessage></h4>
                    </div>
                    <div className="col_100" style={{height: '500px'}}>
                      &nbsp;
                    </div>
                  </div>
                }
                {itms.map((v,i) => {
                  return (
                    <div key={"sitem-" + i} className={"row"} style={{fontSize: "inherit", margin: "auto"}}>
                    <SearchItem Item={v} Referer={ref}/>
                    </div>
                  );
                })}
                <Pager ShowPages={3} Page={this.props.Search.ApiResult.Context.Page} TotalPages={this.props.Search.ApiResult.Context.TotalPages} />
              </React.Fragment>
              }
              {this.props.Groups.Loaded &&
              <React.Fragment>
                {itms.length === 0 &&
                <div className="row">
                  <div className="col_50" id={"noresultsimg"}>
                    <img src={"/imgs/no-results-img.jpg"} width={"200"} height={"200"} alt={"Not Found"}/>
                  </div>
                  <div className="col_50" id={"noresults"}>
                    <h4><FormattedMessage id={"page.noresultsfound"}>{(...content) => content}</FormattedMessage></h4>
                  </div>
                  <div className="col_100" style={{height: '500px'}}>
                    &nbsp;
                  </div>
                </div>
                }
                {itms.map((v,i) => {
                  return (
                    <div key={"group-" + i} className={"row"} style={{fontSize: "inherit", margin: "auto"}}>
                      <h2 style={{marginLeft: "10px", fontSize: "3rem"}}>{v.Title}</h2>
                      {v.Data.map((d,di) => {
                        return <SearchItem key={"group-" + i + "-" + di}Item={d} Referer={ref}/>
                      })}
                    </div>
                  );
                })}
              </React.Fragment>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Content: state.Website.Page.Content,
    WebPage: state.Website,
    Search: state.Search.SearchResults,
    Groups: state.Search.SearchGroups,
  };
}

export default connect(mapStateToProps)(SearchList);
